import React, { PureComponent } from 'react';
import './RedirectTimer.css';

class RedirectTimer extends PureComponent {
  componentDidMount() {
    const {
      redirectUri,
      timer,
    } = this.props;
    window.setTimeout(() => {
      window.location.href = redirectUri;
    }, timer);
  }

  render() {
    const {
      redirectUri,
      message,
    } = this.props;

    return (
      <div className="redirect-timer">
        <p className="redirect-message">{message}</p>
        <a href={redirectUri}>Go now</a>
      </div>
    );
  }
}

export default RedirectTimer;
